var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "chatWindow", attrs: { id: "chat-window-wrapper" } },
    [
      _c("Chat", {
        ref: "chat",
        attrs: {
          contact: _vm.contact,
          messageSyncRunning: _vm.messageSyncRunning,
          messages: _vm.getMessages,
          visitorTypingMessage: _vm.visitorTypingMessage,
          "show-header": _vm.showHeader,
          debugModeEnabled: _vm.debugModeEnabled,
        },
        on: {
          message: _vm.sendMessage,
          debugModeChanged: _vm.handleDebugModeChanged,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }